import React from "react"
import Head from "next/head"
import { Default, MetaKey, MetaProps } from "."

// -----------------------------
// Opengraph Docs — https://ogp.me/
// Facebook Opengraph for Video: https://developers.facebook.com/docs/sharing/webmasters#video

export const TitleTag = (props: MetaProps) => {
  const { title } = props
  // Title tag <title>
  // - if homepage: Bonsai - Tagline goes here
  // - else: Page title — Bonsai

  const pageTitle = !title ? `${Default.SiteName} – ${Default.Tagline}` : `${title} – ${Default.SiteName}`

  // NOTE: Key is required! Next/Head uses those keys to help remove duplicate tags
  return (
    <Head>
      <title data-testid={MetaKey.Title} key={MetaKey.Title}>
        {pageTitle}
      </title>
    </Head>
  )
}
